module.exports = __webpack_public_path__ + "img/traffic.7a755c60.png";